import "./logic.scss";
import { useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { loginUser } from "../../apis/authSlice";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";

const validationSchema = yup.object({
  phone: yup
    .string("Enter your phone number")
    .matches(/^[0-9]+$/, "Phone number must be only digits")
    .min(10, "Phone number should be at least 10 digits")
    .max(10, "Phone number should not be more than 10 digits")
    .required("Phone number is required"),
  password: yup
    .string("Enter your password")  
    .min(6, "Password should be of minimum 6 characters length")
    .required("Password is required"),
});

export default function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [isKeepMelogIn, setIsKeepMelogIn] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleKeepMelogIn = () => setIsKeepMelogIn((prev) => !prev);

  const { authLoading } = useSelector((state) => state.authData);

  const formik = useFormik({
    initialValues: {
      phone: "",
      password: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const response = await dispatch(
        loginUser({ ...values, keepMelogIn: isKeepMelogIn })
      );
      if (response.type.endsWith('/rejected')) {
        toast.warning(response.payload?.message || 'Login failed');
      } else if (response.type.endsWith('/fulfilled')) {
        toast.success(response.payload?.message || 'Login successful');
        navigate("/");
      }
    },
  });
  return (
    <div className="loginMainBox">
      <div className="innerBox">
        <h1>Login</h1>
        <form onSubmit={formik.handleSubmit} className="inputBox">
          <div>
            <InputText
              id="phone"
              name="phone"
              type="number"
              placeholder="Enter Phone no."
              value={formik.values.phone}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={formik.touched.phone && Boolean(formik.errors.phone)}
              className={
                formik.touched.phone && formik.errors.phone ? `errorBorder` : ""
              }
              style={{
                outline: "none",
                border: "none",
                width: "100%",
                height: "4rem",
                backgroundColor: "#E2E2E2",
                borderRadius: "5rem",
                padding: ".2rem 1.5rem",
                fontSize: "1.2rem",
                border: "none",
              }}
              aria-describedby="username-help"
            />
            {formik.touched.phone && formik?.errors?.phone && (
              <small id="username-help" className="text-red-500">
                {formik?.errors?.phone}
              </small>
            )}
          </div>
          <div>
            <div
              style={{
                backgroundColor: "#E2E2E2",
                borderRadius: "5rem",
                border: "none",
              }}
              className={`flex items-center ${
                formik.touched.password && formik.errors.password
                  ? `errorBorder`
                  : ""
              }`}
            >
              <InputText
                id="password"
                name="password"
                type={showPassword ? "text" : "password"}
                placeholder="Enter Password"
                value={formik.values.password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                style={{
                  outline: "none",
                  border: "none",
                  width: "100%",
                  height: "3.9rem",
                  backgroundColor: "inherit",
                  borderRadius: "5rem",
                  padding: ".2rem 0rem 0rem 1.5rem",
                  fontSize: "1.2rem",
                  border: "none",
                }}
                aria-describedby="pass-help"
              />
              <i
                className={`pi pi-${showPassword ? "eye-slash" : "eye"} mr-4`}
                onClick={handleClickShowPassword}
                style={{ fontSize: "1.4rem" }}
              ></i>
            </div>
            {formik.touched.password && formik.errors.password && (
              <small id="pass-help" className="text-red-500">
                {formik?.errors?.password}
              </small>
            )}
          </div>
          <div className="checkboxWrapper">
            <input
              className="inpCbx"
              id="morning"
              type="checkbox"
              onChange={handleKeepMelogIn}
            />
            <label className="cbx" htmlFor="morning">
              <span>
                <svg width="12px" height="10px">
                  <use xlinkHref="#check-4"></use>
                </svg>
              </span>
              <span>Keep Me Logged in</span>
            </label>
            <svg className="inlineSvg">
              <symbol id="check-4" viewBox="0 0 12 10">
                <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
              </symbol>
            </svg>
          </div>
          <Button
            type="submit"
            className="submitButton"
            loading={authLoading}
            label="Login"
            unstyled
          />
        </form>
      </div>
    </div>
  );
}
